import pascaligo from "refractor/pascaligo";
export default pascaligo;